import React from "react";
import { Modal } from "@themuse/design-system";

import styles from "./DirectApplyModal.module.scss";

// generate iframe and modal
const DirectApplyModal = (props: {
    link: string;
    isOpen: boolean;
    setIsOpen: (x: boolean) => void;
}) => {
    const { isOpen, link, setIsOpen } = props;
    // On Safari the body of the iframe is not the same size as the iframe. But instead set to 100% content height.
    // This means that we cannot scroll to an anchor on Safari.
    const label = "Direct Apply Modal.";

    // left empty on purpose
    const openModal = React.useCallback(() => {
        console.info(`The Direct apply modal to ${link} was opened.`);
        // TODO: place onOpen tracking info here
    }, []);

    const closeModal = React.useCallback(() => {
        console.info(`The Direct apply modal to ${link} was closed.`);
        // TODO: place onClose tracking info here
    }, []);

    return (
        <Modal
            label={label}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onOpen={openModal}
            onClose={closeModal}
            timer={0}
            closeButtonClassName={styles.jobApplyModalCloseButton}
            containerClassName={styles.jobApplyModalContainer}
            contentClassName={styles.jobApplyModalContent}
        >
            <iframe
                title="greenhouse apply frame"
                src={`${link}#application`}
                width="300"
                height="500"
                loading="lazy"
                seamless={true}
            />
        </Modal>
    );
};
DirectApplyModal.displayName = "DirectApplyModal";

export {
    DirectApplyModal
};
